import { SolucionPage } from "@/components/SolucionPage";
import { getSolucion } from "@/lib/soluciones";

export default function CampanasWhatsapp() {
  const solucion = getSolucion("campanas-whatsapp")!;
  return <SolucionPage solucion={solucion} />;
}
